import {useGetPremiumStatsQuery} from '~/store/rtkQuery';

export const PremiumStats = () => {
  const {data, isLoading, error} = useGetPremiumStatsQuery();

  return (
    <div className="p-5">
      <h1 className="text-5xl text-center font-semibold">
        Premium Subscriptions
      </h1>
      <div className="flex flex-col items-center justify-center pt-8 gap-4">
        <div>
          {isLoading ? (
            <p className="text-gray-400">Loading</p>
          ) : error ? (
            <p className="text-red-600">Error: {error.message}</p>
          ) : null}
        </div>

        <div className="text-xl text-center">
          <span className="flex gap-2 font-bold">
            <h3 className=" ">Total active teen subscriptions: </h3>
            <p>{data ? data['subscriptionTotalCount'] : '...'}</p>
          </span>
          <p>Premium subscriptions: {data ? data['premiumCount'] : '...'}</p>
          <p>Lifetime subscriptions: {data ? data['lifetimeCount'] : '...'}</p>
          <p>
            Teen subscriptions via ParentPay:{' '}
            {data ? data['parentPayTeenCount'] : '...'}
          </p>
        </div>
      </div>
    </div>
  );
};
